import { Pipe, PipeTransform } from "@angular/core";
import * as _ from "lodash";

@Pipe({
    name: "documentHistoryFilter"
})
export class DocumentHistoryFilterPipe implements PipeTransform {

    public arrquery: any[];
    public temparray: any[];

    public startsWith(char, stringvalue) {
        if ((stringvalue.substring(0, char.length)) == char)
            return true;
        else
            return false;
    } 


    public  transform(array: any[], query: string): any {
        this.arrquery = query.split(",");
        this.temparray = array;
        for (var qry in this.arrquery) {
            var qryvalue = this.arrquery[qry];
            if (qryvalue && qryvalue != "undefined") {

                let arrVal = qryvalue.split("~");
                if ((arrVal[1] && arrVal[1] != "undefined")) {
                    arrVal[1] = arrVal[1].toUpperCase();
                    switch (arrVal[0]) {
                    case "CaseNumber":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.CaseNumber.toUpperCase())));
                            break;
                    case "DocumentType":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.DocumentType.toUpperCase())));
                            break;
                    case "DocumentName":
                            this.temparray = _.filter(this.temparray, (row) => (this.startsWith(arrVal[1], row.DocumentName.toUpperCase())));
                            break;
                    case "Hearing":
                            this.temparray = _.filter(this.temparray, (row) =>
                                row.CalendarEvents &&
                                row.CalendarEvents.length > 0 &&
                                row.CalendarEvents.some(event =>
                                event.HearingDateTime &&
                                new Date(event.HearingDateTime).toISOString().split('T')[0] === query.split("Hearing~")[1]
                                )
                            );
                            break;
                    case "UploadedDate":
                            this.temparray = _.filter(this.temparray, (row) => (!!row.UploadedDate ? row.UploadedDate.indexOf(arrVal[1]) > -1 : !!row.UploadedDate));
                            break;
                    case "UploadedBy":
                            this.temparray = _.filter(this.temparray, (row) => (row.UploadedBy && this.startsWith(arrVal[1], row.UploadedBy.toUpperCase())));
                            break;
                    default:
                    }
                }
            }
        }
        return this.temparray;
    }

}





